<template>
    <div>
        <div class="configurador">
            <div class="configurador-wrap">
                <div class="configurador-header">
                    <div class="configurador-header-title">
                        <p>Escolha o seu</p>
                        <p class="h2">Hyundai</p>
                    </div>
                    <p class="btn-transparent2" @click="handleFilterWindow">Filtro</p>
                </div>
                <div v-if="!isMobile" class="configurador-lstCars">
                    <CarCard :modal.sync="modalState" v-for="(item, i) in handleCarListing" :key="i" :modelObj="item" />
                </div>
                <ListCarsSwiper v-else :carsLst="handleCarListing" />
            </div>
        </div>
        <div class="container-wrapContent">
            <LegalMentions />
            <div class="configSeo" v-html="dataBO.seo"></div>
        </div>
        <FilterConfigurador v-show="openFilter"
        :segments.sync="currSegments"
        :prices.sync="currPrices"
        :rents.sync="currRents"
        :priceRange="handlePriceRentRanges"
        @close-modal="handleFilterWindow" />
    </div>
</template>
<script>
    import { mapGetters, mapMutations, mapState } from 'vuex'
    import CarCard from '../components/Cards/CarCard/CarCard.vue'
    import ListCarsSwiper from '../components/TemplateParts/SwiperConts/ListCarsSwiper.vue'
    import LegalMentions from '../components/TemplateParts/SimpleContent/LegalMentions.vue'
    import { windowResized } from '../mixins/windowEventListeners'
    import FilterConfigurador from '../components/TemplateParts/FilterConfigurador/FilterConfigurador.vue'
    import { metatags } from '../mixins/comonMetaTags'
    import { mainFilterFunc } from '../mixins/filterFunctions'
    import { cookiesFunc } from '../mixins/cookiesFunc'


    export default {
        name: 'Configurador',
        components: { CarCard, ListCarsSwiper, LegalMentions, FilterConfigurador, },
        mixins: [metatags,windowResized,mainFilterFunc,cookiesFunc],
        provide:{ page: 'Configurador'},
        data(){return{
            seoData: {
                "title": "Configurador",
                'titleTemplate': 'Gama Hyundai',
                "author": "Hyundai Portugal",
                "og_description": "Com o Configurador Hyundai, pode escolher e personalizar o seu Hyundai de sonho. Selecione o seu modelo favorito e escolha todas as características de acordo com as suas preferências.",
                "og_title": "Configurador Hyundai - Hyundai Portugal",
                "og_locale": "pt_PT",
                "og_type": "article",
                "og_site_name": "Hyundai Portugal"
            },
            modalState: false,
            openFilter: false,
            currSegments: [],
            currPrices: [],
            currRents: [],
            oldCfg: false,
        }},
        beforeMount(){
            this.loadConfiguration()
        },
        mounted(){
            let nav = document.querySelector('.navbar');
            if(nav){nav.style.display = 'flex'}

            // RESET
            !this.oldCfg && this.resetResumeData();
            this.resetNavSteps();

            let sessionID = this.getCookieValue('wp_cfgHyu_sessionID')
            let uniqueID = this.getCookieValue('wp_cfgHyu_uniqueID')
            this.changeResumeState({sessionID: sessionID, uniqueID: uniqueID})
        },
        beforeRouteLeave(to, prev, next){
            if(this.resumeData.modelid == null || to.name == 'Resume'){
                alert('É necessário selecionar um modelo antes de prosseguir!')
                return false
            }
            next()
        },
        watch:{
            openFilter: function(val){
                if(this.isMobile){
                   val ?  document.body.classList.add('isActive') : document.body.classList.remove('isActive')
                }else{
                    document.body.classList.remove('isActive')
                }
            },
        },
        computed: {
            ...mapState(['dataBO', 'resumeData']),
            ...mapGetters({
                carsLst: 'getSortedCarsLstByPrice',
                getModelNameById: 'getModelNameById',
            }),
            handleCarListing(){
                let segLgh = this.currSegments.length;
                let priceLgh = this.currPrices.length;
                let rentLgh = this.currRents.length;

                if(segLgh != 0){
                    let cars = this.filterBySegments(this.carsLst)
                    if(priceLgh != 0){
                        let _cars = this.filterByPrice(cars)
                        if(rentLgh != 0) return this.filterByRent(_cars)
                        return _cars
                    }
                    if(rentLgh != 0) return this.filterByRent(cars)
                    return cars
                }

                if(priceLgh != 0){
                    let cars = this.filterByPrice(this.carsLst)
                    if(rentLgh != 0) return this.filterByRent(cars)
                    return cars
                }

                if(rentLgh != 0) return this.filterByRent(this.carsLst)
                return this.carsLst;
            },
            handlePriceRentRanges(){
                if(this.carsLst.length == 0) return false;
                return {
                    maxPrice: this.getMinMax('price', true).price,
                    minPrice: this.getMinMax('price').price,
                    maxRent: this.getMinMax('rent', true).rent,
                    minRent: this.getMinMax('rent').rent,
                }
            }
        },
        methods:{
            ...mapMutations({
                updateResumeState: 'resumeData/UPDATE_STATE',
                resetResumeData: 'resumeData/CLEAR_STATE',
                resetNavSteps: 'navbarState/RESET_STEPS',
                changeResumeState: 'resumeData/UPDATE_STATE',
            }),
            handleFilterWindow(){
                this.openFilter = !this.openFilter
            },
            getMinMax(atrb, max=false){
                let _arr = this.filterBySegments(this.carsLst)
                if(_arr.length == 0) return 0
                if(max) return _arr.reduce((prev, curr) => prev[atrb] > curr[atrb] ? prev : curr);
                return _arr.reduce((prev, curr) => prev[atrb] < curr[atrb] ? prev : curr);
            },
            loadConfiguration(){

                /**
                 * Pre load Model, check for php template for params.
                 */

                let cookie = this.getCookieValue('wp_cfgHyu')
                let arr = cookie != '' ? JSON.parse(decodeURIComponent(cookie.replace(/\+/g, ' '))) : null
                if(!arr || !arr.modelid) return false

                this.oldCfg = true
                let modelid = arr?.modelid
                let model = modelid ? this.getModelNameById(modelid) : undefined
                let engine = arr.engine
                let vers = arr.version
                let ext = arr.colext
                let int = arr.colint

                this.$store.dispatch('images360/fetch360Model', modelid);
                this.updateResumeState({
                    newCfg: false,
                    model: model,
                    modelid: modelid,
                    selectedEngine: engine,
                    versionID: vers,
                    configSelected: {
                        dsgExt: { colorid: ext },
                        dsgInt: { colorid: int},
                    },
                })

                // const paths = [ 'motor', 'versao', 'exterior', 'interior', 'resumo' ]

                let motorPath = '/' + model + '/motor'
                this.$router.replace(motorPath)
                this.eraseCookie('wp_cfgHyu')
            }
        },
    }
</script>
<style lang="scss">
    .configurador{ background-color: $grayBgLighterCol;

        &-wrap{
            display: flex;
            flex-direction: column;
            // @include defaultPadding();
            // @extend %container;

            @include simpleContainer();
        }

        &-header{
            display: flex;
            justify-content: space-between;
            margin: 2.25rem 0 2rem;

            &-title{
                p{
                    @include mixin_textContent(1.125rem, 1.125rem, $regular, $grayDarkCol);
                    margin-bottom: .5rem
                }
                .h2{ @include mixin_textContent(1.5rem, 1.5rem, $medium, $grayDarkCol); }
            }

            .btn-transparent2{
                cursor: pointer;
                width: 75px;
                user-select: none;
            }
        }
    }

    .configSeo{ margin-top: 4rem;

        h1{
            margin-bottom: .25rem;
            @include mixin_textContent(1.125rem, 1.5rem, $medium, $grayLightCol);
        }
        .h2{
            margin: 2rem 0 .25rem;
            @include mixin_textContent(1rem, 1.5rem, $medium, $grayLightCol);
        }
        h3{
            @include mixin_textContent(.75rem, 1.5rem, $regular, $grayLightCol);
        }
    }

    @include respond-to(large){
        .configSeo{ margin-top: 7rem; }

        .configurador{
            &-wrap{
                padding: 2rem 0;
                flex-direction: row;
                justify-content: space-between;
            }

            &-header{
                flex-basis: 20%;
                flex-direction: column;
                justify-content: flex-start;

               &-title{
                    p{font-size: 1.132rem;}
                    .h2{
                        @include mixin_textContent_desktop(3rem, 3rem);
                        margin-bottom: 1.5rem;
                    }
               }
            }
            &-lstCars{
                flex-basis: 70%;
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
                -ms-grid-columns: repeat(auto-fill, minmax(16rem, 1fr));
                gap: .75rem;
                row-gap: 2rem;
            }
        }
    }
</style>
